import * as React from "react"
import { Link, graphql } from "gatsby"

import Bio from "../components/bio"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { NetEaseMusicPlayer } from "../components/NetEaseMusicPlayer"
import { InlineTags } from "../components/InlineTags"
import { Comments } from "../components/Comments"
import { SponsorButtons } from "../components/SponsorButtons"

const WeeklyTemplate = ({
  data: { previous, next, site, markdownRemark: post },
  location,
}) => {
  const siteTitle = site.siteMetadata?.title || `Title`

  return (
    <Layout location={location} title={siteTitle}>
      <article
        className="blog-post"
        itemScope
        itemType="http://schema.org/Article"
      >
        <header>
          <h1 itemProp="headline">{post.frontmatter.title}</h1>
          <p>{post.frontmatter.date}</p>
        </header>
        <InlineTags tags={post.frontmatter.tags} />
        {post.frontmatter.songs && post.frontmatter.songs.length > 0 && (
          <div style={{ marginBottom: "1.5em" }}>
            <NetEaseMusicPlayer songs={post.frontmatter.songs} />
          </div>
        )}
        <section
          className="prose"
          dangerouslySetInnerHTML={{ __html: post.html }}
          itemProp="articleBody"
        />
        <hr className="mt-8" />
        <footer>
          <Bio style={{ marginBottom: 0 }}>
            <div>
              <p style={{ marginBottom: "var(--spacing-4)" }}>
                如果你喜欢阅读我的 weekly，不妨考虑赞助我下周的共享单车费 💖。
              </p>
              <SponsorButtons />
            </div>
          </Bio>
        </footer>
      </article>
      <nav className="blog-post-nav">
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={"/weekly" + previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={"/weekly" + next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
      </nav>
      <Comments />
    </Layout>
  )
}

export const Head = ({ data: { markdownRemark: post } }) => {
  return (
    <Seo
      title={post.frontmatter.title}
      description={post.frontmatter.description || post.excerpt}
      twitterImage={post.frontmatter.image?.childImageSharp.fixed.src}
    />
  )
}

export default WeeklyTemplate

export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        songs {
          name
          ar {
            id
            name
          }
          mediaUrl
          al {
            picUrl
          }
          lrc
        }
        tags
        image {
          childImageSharp {
            fixed(height: 628, width: 1200) {
              src
            }
          }
        }
      }
    }
    previous: markdownRemark(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: markdownRemark(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`
